var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"store-locator-around-me base-btn base-btn--primary",attrs:{"type":"button"},on:{"click":_vm.getPosition}},[_vm._v("\n  "+_vm._s(_vm.$t('label'))+"\n  "),_c('span',{staticClass:"icon icon--marker"})])}
var staticRenderFns = []

export { render, staticRenderFns }